<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgSignUpDialog.title' | translate }}
      </h3>
      <button (click)="onCloseDialog()" type="button" class="modal__close">
        <img src="assets/images/icons/close.svg" />
      </button>
    </div>
    <div class="modal__body">
      <bkg-dialog-banner
        [isVisible]="!!errorMessage"
        [message]="errorMessage"
        (closeBanner)="onCloseErrorBanner()"
      >
      </bkg-dialog-banner>
      <p>
        {{ 'sharedModule.bkgSignUpDialog.bodyTitle' | translate }}
      </p>
      <div class="login">
        <div class="login__external" *ngIf="!hasSocialUser">
          <button
            (click)="onLoadFacebookData()"
            type="button"
            class="btn-facebook"
          >
            {{ 'sharedModule.bkgSignUpDialog.signUpWithFb' | translate }}
          </button>

          <button (click)="onLoadGoogleData()" type="button" class="btn-google">
            {{ 'sharedModule.bkgSignUpDialog.signUpWithGoogle' | translate }}
          </button>

          <button
            *ngIf="isIos"
            (click)="onLoadAppleData()"
            type="button"
            class="btn-apple"
          >
            {{ 'sharedModule.bkgSignUpDialog.signUpWithApple' | translate }}
          </button>
        </div>

        <bkg-separator *ngIf="!hasSocialUser"></bkg-separator>

        <form *ngIf="form" [formGroup]="form" id="signupForm" errorTailor>
          <div class="login__form-row">
            <div class="form-group" [class.success]="isValidField('name')">
              <label for="signup-name" class="sr-only">{{
                'sharedModule.bkgSignUpDialog.name' | translate
              }}</label>
              <input
                formControlName="name"
                type="text"
                id="signup-name"
                placeholder="{{
                  'sharedModule.bkgSignUpDialog.name' | translate
                }}"
                controlErrorsClass="info-field"
                [class.warning]="hasErrors('name')"
              />
            </div>

            <div class="form-group" [class.success]="isValidField('surname')">
              <label for="signup-surname" class="sr-only">{{
                'sharedModule.bkgSignUpDialog.surname' | translate
              }}</label>
              <input
                formControlName="surname"
                type="text"
                id="signup-surname"
                placeholder="{{
                  'sharedModule.bkgSignUpDialog.surname' | translate
                }}"
                [class.warning]="hasErrors('surname')"
                controlErrorsClass="info-field"
              />
            </div>
          </div>

          <div class="login__form-row">
            <div class="form-group" [class.success]="isValidField('email')">
              <label for="signup-email" class="sr-only">{{
                'sharedModule.bkgSignUpDialog.email' | translate
              }}</label>
              <input
                formControlName="email"
                type="email"
                id="signup-email"
                placeholder="{{
                  'sharedModule.bkgSignUpDialog.email' | translate
                }}"
                [class.warning]="hasErrors('email')"
                controlErrorsClass="info-field"
              />
            </div>

            <div
              *ngIf="!hasSocialUser"
              class="form-group"
              [class.success]="isValidField('password')"
            >
              <label for="signup-password" class="sr-only">{{
                'sharedModule.bkgSignUpDialog.password' | translate
              }}</label>
              <input
                formControlName="password"
                type="password"
                id="signup-password"
                placeholder="{{
                  'sharedModule.bkgSignUpDialog.password' | translate
                }}"
                [class.warning]="hasErrors('password')"
                controlErrorsClass="info-field"
              />
            </div>
          </div>

          <div class="login__form-row--checks">
            <div class="form-group">
              <input
                formControlName="privacyPolicy"
                type="checkbox"
                id="signup-privacy"
                controlErrorsIgnore
              />
              <label for="signup-privacy">
                <span
                  [innerHTML]="
                    'sharedModule.bkgSignUpDialog.privacyPolicy' | translate
                  "
                ></span>
              </label>
            </div>

            <div class="form-group">
              <input
                formControlName="acceptPromos"
                type="checkbox"
                id="signup-promos"
                controlErrorsIgnore
              />
              <label for="signup-promos">
                {{ 'sharedModule.bkgSignUpDialog.promoEmails' | translate }}
              </label>
            </div>

            <div class="form-group">
              <input
                formControlName="acceptNewsletter"
                type="checkbox"
                id="signup-emails"
                controlErrorsIgnore
              />
              <label for="signup-emails">
                {{
                  'sharedModule.bkgSignUpDialog.newsletterEmails' | translate
                }}
              </label>
            </div>
          </div>

          <button
            (click)="onCreateUser()"
            type="button"
            [class.disabled]="isInvalidForm || requestActive"
            [class.mt-4]="hasSocialUser"
            [class.modal__margin-bottom]="reservationData?.id"
            class="btn-primary btn-large is-block"
          >
            {{ 'sharedModule.bkgSignUpDialog.signUpFree' | translate }}
          </button>

          <button
            type="button"
            *ngIf="hasSocialUser"
            (click)="onCancelSocialUser()"
            class="btn-primary btn-large is-block mt-4"
          >
            {{ 'sharedModule.bkgSignUpDialog.cancel' | translate }}
          </button>

          <p *ngIf="!reservationData?.id" class="login__form-extra">
            {{ 'sharedModule.bkgSignUpDialog.haveAccount' | translate }}
            <a (click)="navigateToLogin()" class="link">{{
              'sharedModule.bkgSignUpDialog.access' | translate
            }}</a>
          </p>
        </form>
      </div>
    </div>
    <div class="modal__footer has-border">
      <a (click)="onContinue()" class="login__footer link">
        <span *ngIf="showContinue">
          {{ 'sharedModule.bkgSignUpDialog.continueBtn' | translate }}
        </span>
        <span *ngIf="!showContinue">
          {{ 'sharedModule.bkgSignUpDialog.cancel' | translate }}
        </span>
      </a>
    </div>
  </div>
</div>
